import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LoginComponent } from './login/login.component';
import { TogglePasswordComponent } from './toggle-password/toggle-password.component';
import { LogModule, SpinnerModule, SystemNotificationModule } from '@wfm/core';
import { WfmhomecallbackComponent } from './login/wfmhomecallback.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    AngularSvgIconModule,
    LogModule,
    SpinnerModule,
    SystemNotificationModule
  ],
  declarations: [LoginComponent, TogglePasswordComponent, WfmhomecallbackComponent]
})
export class AuthenticationModule {}
